var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.938v6.78h7c1.063 0 2 .909 2 1.938 0 1.09-.938 1.938-2 1.938h-7v6.781c0 1.09-.938 1.938-2 1.938-1.125 0-2-.848-2-1.938v-6.781h-7c-1.125 0-2-.848-2-1.938 0-1.029.875-1.937 2-1.937h7V6.938C18 5.907 18.875 5 20 5c1.063 0 2 .908 2 1.938zM8 33.063c0-1.03.875-1.938 2-1.938h20c1.063 0 2 .908 2 1.938 0 1.09-.938 1.937-2 1.937H10c-1.125 0-2-.848-2-1.938z"
  })));
}
export default SvgAddRemove;